/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminOverrideMatchScoreBody
 */
export interface AdminOverrideMatchScoreBody {
    /**
     * 
     * @type {number}
     * @memberof AdminOverrideMatchScoreBody
     */
    team1Score: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOverrideMatchScoreBody
     */
    team2Score: number;
    /**
     * Why the result is being set by an admin. Recorded on the match and in the audit log.
     * @type {string}
     * @memberof AdminOverrideMatchScoreBody
     */
    reason: string;
}

/**
 * Check if a given object implements the AdminOverrideMatchScoreBody interface.
 */
export function instanceOfAdminOverrideMatchScoreBody(value: object): value is AdminOverrideMatchScoreBody {
    if (!('team1Score' in value) || value['team1Score'] === undefined) return false;
    if (!('team2Score' in value) || value['team2Score'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AdminOverrideMatchScoreBodyFromJSON(json: any): AdminOverrideMatchScoreBody {
    return AdminOverrideMatchScoreBodyFromJSONTyped(json, false);
}

export function AdminOverrideMatchScoreBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOverrideMatchScoreBody {
    if (json == null) {
        return json;
    }
    return {
        
        'team1Score': json['team1Score'],
        'team2Score': json['team2Score'],
        'reason': json['reason'],
    };
}

export function AdminOverrideMatchScoreBodyToJSON(json: any): AdminOverrideMatchScoreBody {
    return AdminOverrideMatchScoreBodyToJSONTyped(json, false);
}

export function AdminOverrideMatchScoreBodyToJSONTyped(value?: AdminOverrideMatchScoreBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'reason': value['reason'],
    };
}

